export * from './lock-icon'
